export default __webpack_public_path__ + "static/media/expl-dissect_09_DE.1809678c.png";